export default "__VITE_ASSET__DNIf0bQE__"